"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isUsingChrome2 = require("../utils/isUsingChrome");

var _Utils = require("../utils/Utils");

var ChromeExtensionInstallHelpers =
/*#__PURE__*/
function () {
  function ChromeExtensionInstallHelpers() {
    (0, _classCallCheck2.default)(this, ChromeExtensionInstallHelpers);
    this.authorizedWebstoreDomain = null;
    this.extensionUrl = null;
    this.isUsingChrome = (0, _isUsingChrome2._isUsingChrome)();
    this._isExtensionInstalled = false;
    this.setup();
  } // Deprecated: no longer necessary to have a mock install process, since tryExtensionInstall just opens a new window.


  (0, _createClass2.default)(ChromeExtensionInstallHelpers, [{
    key: "installDebug",
    value: function installDebug() {
      return false;
    }
  }, {
    key: "onInstallSuccess",
    value: function onInstallSuccess(callback) {
      var _this = this;

      return function () {
        _this._isExtensionInstalled = true;

        if ((0, _Utils.isFunction)(callback)) {
          callback();
        }
      };
    }
  }, {
    key: "tryExtensionInstall",
    value: function tryExtensionInstall(onSuccess) {
      onSuccess = this.onInstallSuccess(onSuccess);
      window.open(this.extensionUrl, '_blank');
      return onSuccess();
    }
  }]);
  return ChromeExtensionInstallHelpers;
}();

var _default = ChromeExtensionInstallHelpers;
exports.default = _default;
module.exports = exports.default;